import { useCallback, useState } from 'react';

const MAX = 5;
const keyFor = (userId) => `strata:header-search:recent:${userId || 'anon'}`;

const read = (key) => {
  try {
    const v = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string').slice(0, MAX) : [];
  } catch { return []; }
};

// This person's last 5 header searches on this browser (newest first, no repeats).
export default function useRecentSearches(userId) {
  const key = keyFor(userId);
  const [items, setItems] = useState(() => read(key));
  const save = (next) => { setItems(next); try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* storage off */ } };

  const add = useCallback((term) => {
    const t = String(term || '').trim();
    if (!t) return;
    const cur = read(key);
    save([t, ...cur.filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, MAX));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  const clear = useCallback(() => save([]), [key]); // eslint-disable-line react-hooks/exhaustive-deps

  return { items, add, clear };
}
